import Card from "../../../../components/Card";
import Modal from "../../../../components/Modal";
import { useUser } from "../../../../context";
import raffle from "../../../../i11/Raffle";
import styles from "./Prizes.module.sass";
import Checkbox from "../../../../components/Checkbox";
import cn from "classnames";
import { GetNFTTemplates } from "../../../../Services/lib/nfttemplates";
import { UseApi } from "../../../../hooks/use-api";
import { useEffect, useState } from "react";
import Form from "../../../../components/Form";
import Empthy from "../../../../components/Empty";
import Loader from "../../../../components/Loader";
import { GetNFTsBrand, GetWalletNFTsAdmin } from "../../../../Services/lib/nft";

const PrizesModal = ({
	isOpen: isOpen_,
	onClose: onClose_,
	filter,
	setFilter,
	setLocal,
}) => {
	const [index, setIndex] = useState(0);
	const { locale } = useUser();
	const [nft, setNft] = useState([]);
	const [{ isLoading: isLoadingTemplate }, getNFTTemplates] = UseApi({
		service: GetNFTTemplates,
	});
	const [{ isLoading: isLoadingNft }, getNFTs] = UseApi({
		service: GetWalletNFTsAdmin,
	});
	const [filterNft, setFilterNft] = useState({
		limit: 20,
		search: "",
		order_direction: -1,
		order_by: "createdAt",
	});
	const [filterTemplates, setFilterTemplates] = useState({
		offset: 0,
		limit: 20,
		sortBy: "updatedAt",
		orderBy: "desc",
		status: "OPEN",
		name: "",
		nftTypes: [],
	});

	const getNFTs_ = async () => {
		let his;
		let res = [];
		his !== index && setNft([]);
		if (index === 0) {
			res = await getNFTTemplates(filterTemplates);
			if (res && res?.nftTemplates) {
				setNft(res.nftTemplates);
			}
		} else {
			res = await getNFTs(filterNft);
			if (res && res?.list) {
				setNft(res.list);
			}
		}
		his = index;
	};
	useEffect(() => {
		getNFTs_();
	}, [filterTemplates, index, filterNft]);
	const close = () => {
		onClose_();
	};
	const handleChange = (item) => {
		item.type = index === 0 ? "Template" : "NFT";
		let select_ = [...filter];
		if (filter.some((obj) => obj._id === item._id)) {
			select_ = filter.filter((x) => x._id !== item._id);
			setFilter(select_);
		} else {
			select_ = [...select_, item];
			setFilter((s) => [...s, item]);
		}
		setLocal((local) => {
			return {
				...local,
				prizes: [
					...select_.map((prize) => {
						return {
							id: prize._id,
							type: prize.type,
						};
					}),
				],
			};
		});

		console.log("select_ : ", select_);
	};
	return (
		<>
			<Modal
				outSideClickNone
				outerClassName={styles.outer}
				visible={isOpen_}
				onClose={close}
			>
				<Card
					className={styles.card}
					title={raffle[locale].sel_prices}
					classTitle="title-yellow"
					head={
						<>
							<Form
								placeholder={
									(index === 0 ? "Listing " : "NFT ") +
									raffle[locale].search
								}
								type="text"
								name="search"
								icon="search"
								required={false}
								setValue={(val) => {
									if (index === 0) {
										setFilterTemplates((e) => {
											return { ...e, name: val };
										});
									} else {
										setFilterNft((e) => {
											return { ...e, search: val };
										});
									}
								}}
							/>
						</>
					}
				>
					<div className={styles.control}>
						<div className={styles.nav}>
							{["Listing", "NFT"].map((x, i) => (
								<button
									key={"__button__" + i}
									className={cn(styles.link, {
										[styles.active]: i === index,
									})}
									onClick={() => setIndex(i)}
								>
									{x}
								</button>
							))}
							{(isLoadingTemplate || isLoadingNft) && (
								<div className={styles.loaderWrap}>
									<Loader />
								</div>
							)}
						</div>
					</div>

					<div className={styles.maxHeight}>
						{nft.length !== 0
							? nft.map((e) => {
									return (
										<Row
											getList={() => {}}
											key={e._id}
											data={e}
											value={filter.some(
												(obj) => obj._id === e._id
											)}
											onChange={() => handleChange(e)}
										/>
									);
							  })
							: !(isLoadingTemplate || isLoadingNft) && (
									<Empthy />
							  )}
					</div>
					<div className={styles.buttonContainer}>
						<button onClick={onClose_} className="button-small">
							{raffle[locale].ok}
						</button>
					</div>
				</Card>
			</Modal>
		</>
	);
};

const Row = ({ data, value, onChange }) => {
	return (
		<div className={styles.row}>
			<Checkbox value={value} onChange={onChange} />

			<div className={styles.row} onClick={onChange}>
				<div className={styles.img}>
					<img
						src={data?.image || "/images/content/product-pic-6.jpg"}
						alt={"_image"}
					/>
				</div>
				{data.name}
			</div>
		</div>
	);
};

export default PrizesModal;
